<div class="header_hero-bg"></div>

<div class="mega-trade-container container-fluid">
  <div class="mega_body-content">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 mega_header-information">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
          <div class="mega_header-information__sub-header">Settled Pools</div>
        </div>
        <p class="col-12 col-sm-12 col-md-6 col-lg-6 settled-mega-text">
          Below is a list of your settled pools.
        </p>
      </div>
    </div>

    <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break-container">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break__padding">
          <div class="line-break"></div>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-12 col-md-12 col-lg-12 mega_header-information-settled">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 settled-mega-tab">
          <div
            class="col-12 col-sm-12 col-md-2 col-lg-2 selectable-tab"
            (click)="megaTypeSelected('SFFIXMEGA')"
            [ngClass]="{ 'selected-mega-type-text': isSingleFamilyFixTabSelected }"
          >
            <div class="settled-mega-tab-text">Single Family Fixed Rate</div>
            <div
              class="line-break-tab"
              [ngClass]="{ 'selected-mega-type-border': isSingleFamilyFixTabSelected }"
            ></div>
          </div>

          <div
            class="col-12 col-sm-12 col-md-2 col-lg-2 selectable-tab"
            (click)="megaTypeSelected('SFARMMEGA')"
            [ngClass]="{ 'selected-mega-type-text': isSingleFamilyArmTabSelected }"
          >
            <div class="settled-mega-tab-text">Single Family ARM</div>
            <div
              class="line-break-tab"
              [ngClass]="{ 'selected-mega-type-border': isSingleFamilyArmTabSelected }"
            ></div>
          </div>

          <div
            class="col-12 col-sm-12 col-md-2 col-lg-2 selectable-tab"
            (click)="megaTypeSelected('MFFIXMEGA')"
            [ngClass]="{ 'selected-mega-type-text': isMultiFamilyFixTabSelected }"
          >
            <div class="settled-mega-tab-text">Multi Family Fixed Rate</div>
            <div
              class="line-break-tab"
              [ngClass]="{ 'selected-mega-type-border': isMultiFamilyFixTabSelected }"
            ></div>
          </div>

          <div
            class="col-12 col-sm-12 col-md-2 col-lg-2 selectable-tab"
            (click)="megaTypeSelected('MFARMMEGA')"
            [ngClass]="{ 'selected-mega-type-text': isMultiFamilyArmTabSelected }"
          >
            <div class="settled-mega-tab-text">Multi Family ARM</div>
            <div
              class="line-break-tab"
              [ngClass]="{ 'selected-mega-type-border': isMultiFamilyArmTabSelected }"
            ></div>
          </div>

          <div class="col-12 col-sm-12 col-md-4 col-lg-4 view-dropdown-container">
            <label class="time-select-lable" for="timeSpan">View:</label>
            <div class="fm-cdx-select">
              <select
                id="timeSpan"
                [ngModel]="selectedTimeSpan"
                (ngModelChange)="setSelectedTimeSpan($event)"
              >
                <option
                  *ngFor="let timeSpan of timeSpanSelectionArray; trackBy: trackByIdentity"
                  [ngValue]="timeSpan"
                >
                  {{ timeSpan }}
                </option>
              </select>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break-tab-select"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-12 col-md-12 col-lg-12 mega_header-information-settled">
      <ng-container *ngIf="showMessage">
        <div class="row settled-mega-table">
          <div class="col-12 col-sm-12 col-md-6 col-lg-6">
            <p>{{ errorMessage }}</p>
            <p>Would you like to create a new pool now?</p>
            <div class="create-mega-buttons-row">
              <div class="col-12 col-sm-12 col-md-4 col-lg-4 create-mega-button">
                <button
                  class="button fm-primary-button col-12 bulk-mega-button single-mega-button-width"
                  [disabled]="!hasCreateOrEditMegaAccessFlag"
                  (click)="navigatePageTo('/mega-trade/enter-details')"
                >
                  CREATE SINGLE POOL
                </button>
              </div>
              <div class="col-12 col-sm-12 col-md-5 col-lg-5 create-mega-button">
                <button
                  class="button fm-primary-button col-12 bulk-mega-button bulk-mega-button-width"
                  [disabled]="!hasCreateOrEditMegaAccessFlag"
                  (click)="navigatePageTo('bulk-upload/enter-mega-details')"
                >
                  CREATE MULTIPLE POOLS
                </button>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="!showMessage">
        <div class="row settled-mega-table">
          <div class="row megabanner">
            <div class="col-12 col-sm-12 col-md-6 col-lg-6">
              <span class="mega-type-banner">Pool Type</span>
              <ng-container *ngIf="isSingleFamilyFixTabSelected">
                <h2 class="mega-type-header-banner">Single Family Fixed Rate</h2>
              </ng-container>
              <ng-container *ngIf="isSingleFamilyArmTabSelected">
                <h2 class="mega-type-header-banner">Single Family ARM</h2>
              </ng-container>
              <ng-container *ngIf="isMultiFamilyFixTabSelected">
                <h2 class="mega-type-header-banner">Multi Family Fixed Rate</h2>
              </ng-container>
              <ng-container *ngIf="isMultiFamilyArmTabSelected">
                <h2 class="mega-type-header-banner">Multi Family ARM</h2>
              </ng-container>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-6 text-end">
              <span class="mega-type-banner">Current Month Settled Volume</span>
              <ng-container *ngIf="isSingleFamilyFixTabSelected">
                <h2 class="mega-type-header-banner">
                  {{ totalSettledVolumeSFFIXMEGA | currency: 'USD' : 'symbol' : '1.2-2' }}
                </h2>
              </ng-container>
              <ng-container *ngIf="isSingleFamilyArmTabSelected">
                <h2 class="mega-type-header-banner">
                  {{ totalSettledVolumeSFARMMEGA | currency: 'USD' : 'symbol' : '1.2-2' }}
                </h2>
              </ng-container>
              <ng-container *ngIf="isMultiFamilyFixTabSelected">
                <h2 class="mega-type-header-banner">
                  {{ totalSettledVolumeMFFIXMEGA | currency: 'USD' : 'symbol' : '1.2-2' }}
                </h2>
              </ng-container>
              <ng-container *ngIf="isMultiFamilyArmTabSelected">
                <h2 class="mega-type-header-banner">
                  {{ totalSettledVolumeMFARMMEGA | currency: 'USD' : 'symbol' : '1.2-2' }}
                </h2>
              </ng-container>
            </div>
          </div>
          <div class="fm-cdx-table">
            <ng-container
              *ngIf="isSingleFamilyFixTabSelected && !showMessage && settledSfFixMega != null"
            >
              <table class="fm-cdx-table__static">
                <thead>
                  <tr class="th_row">
                    <th
                      class="th_column th_sortable-column sortable-column"
                      (click)="sortByGridByColumnName('poolNumber')"
                    >
                      <span>POOL #</span>
                      <a class="column-name">
                        <i
                          class="sorting-icon-down fa fa-caret-down {{
                            presentSortedColumn === 'poolNumber'
                              ? presentSortedColumnIsAscending
                                ? ''
                                : 'in-active-icon'
                              : 'in-active-icon'
                          }}"
                        ></i>
                        <i
                          class="sorting-icon-up fa fa-caret-up {{
                            presentSortedColumn === 'poolNumber'
                              ? presentSortedColumnIsAscending
                                ? 'in-active-icon'
                                : ''
                              : 'in-active-icon'
                          }}"
                        ></i>
                      </a>
                    </th>

                    <th
                      class="th_column th_sortable-column sortable-column"
                      (click)="sortByGridByColumnName('cusip')"
                    >
                      <span>cusip</span>
                      <a class="column-name">
                        <i
                          class="sorting-icon-down fa fa-caret-down {{
                            presentSortedColumn === 'cusip'
                              ? presentSortedColumnIsAscending
                                ? ''
                                : 'in-active-icon'
                              : 'in-active-icon'
                          }}"
                        ></i>
                        <i
                          class="sorting-icon-up fa fa-caret-up {{
                            presentSortedColumn === 'cusip'
                              ? presentSortedColumnIsAscending
                                ? 'in-active-icon'
                                : ''
                              : 'in-active-icon'
                          }}"
                        ></i>
                      </a>
                    </th>

                    <th class="th_column">prefix</th>
                    <th class="th_column th_column--is-numeric">coupon</th>

                    <th
                      class="th_column th_column--is-numeric th_sortable-column sortable-column"
                      (click)="sortByGridByColumnName('tradeAmount')"
                    >
                      <span>deal amount</span>
                      <a class="column-name">
                        <i
                          class="sorting-icon-down fa fa-caret-down {{
                            presentSortedColumn === 'tradeAmount'
                              ? presentSortedColumnIsAscending
                                ? ''
                                : 'in-active-icon'
                              : 'in-active-icon'
                          }}"
                        ></i>
                        <i
                          class="sorting-icon-up fa fa-caret-up {{
                            presentSortedColumn === 'tradeAmount'
                              ? presentSortedColumnIsAscending
                                ? 'in-active-icon'
                                : ''
                              : 'in-active-icon'
                          }}"
                        ></i>
                      </a>
                    </th>

                    <th
                      class="th_column th_sortable-column sortable-column"
                      (click)="sortByGridByColumnName('tradeSettlementDate')"
                    >
                      <span>settlement</span>
                      <a class="column-name">
                        <i
                          class="sorting-icon-down fa fa-caret-down {{
                            presentSortedColumn === 'tradeSettlementDate'
                              ? presentSortedColumnIsAscending
                                ? ''
                                : 'in-active-icon'
                              : 'in-active-icon'
                          }}"
                        ></i>
                        <i
                          class="sorting-icon-up fa fa-caret-up {{
                            presentSortedColumn === 'tradeSettlementDate'
                              ? presentSortedColumnIsAscending
                                ? 'in-active-icon'
                                : ''
                              : 'in-active-icon'
                          }}"
                        ></i>
                      </a>
                    </th>

                    <th class="th_column th_column--is-numeric">fee</th>

                    <th
                      class="th_column th_sortable-column sortable-column"
                      (click)="sortByGridByColumnName('committedDate')"
                    >
                      <span>committed</span>
                      <a class="column-name">
                        <i
                          class="sorting-icon-down fa fa-caret-down {{
                            presentSortedColumn === 'committedDate'
                              ? presentSortedColumnIsAscending
                                ? ''
                                : 'in-active-icon'
                              : 'in-active-icon'
                          }}"
                        ></i>
                        <i
                          class="sorting-icon-up fa fa-caret-up {{
                            presentSortedColumn === 'committedDate'
                              ? presentSortedColumnIsAscending
                                ? 'in-active-icon'
                                : ''
                              : 'in-active-icon'
                          }}"
                        ></i>
                      </a>
                    </th>
                    <th class="th_column">
                      <span>COLLATERAL</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="td_row"
                    *ngFor="
                      let settledMega of settledSfFixMega.megaList | paginate: config;
                      trackBy: trackByIdentity
                    "
                  >
                    <td
                      class="td_cell poolNumber cusip-disclosure"
                      (click)="openDisclosure(settledMega, settledSfFixMega)"
                    >
                      {{ settledMega?.poolNumber }}
                    </td>
                    <td class="td_cell">{{ settledMega?.cusip }}</td>
                    <td class="td_cell">{{ settledMega?.prefixCode }}</td>
                    <td class="td_cell td_cell--is-numeric">{{ settledMega?.sfFixedCoupon }}</td>
                    <td class="td_cell td_cell--is-numeric">
                      {{ settledMega?.tradeAmount | currency: 'USD' : 'symbol' : '1.0' }}
                    </td>
                    <td class="td_cell">
                      {{ settledMega?.tradeSettlementDate | date: 'MM/dd/yyyy' }}
                    </td>

                    <ng-container *ngIf="settledMega.feeTicks != null">
                      <td class="td_cell td_cell--is-numeric">{{ settledMega?.feeTicks }}/32</td>
                    </ng-container>

                    <ng-container *ngIf="settledMega.feeDollars != null">
                      <ng-container
                        *ngIf="needsDisclaimer(settledMega?.prefixCode); else noDisclaimer"
                      >
                        <td class="td_cell td_cell--is-numeric fee-warning-red">
                          {{ settledMega?.feeDollars | currency: 'USD' : 'symbol' : '1.2-2' }}*
                        </td>
                      </ng-container>
                      <ng-template #noDisclaimer>
                        <td class="td_cell td_cell--is-numeric">
                          {{ settledMega?.feeDollars | currency: 'USD' : 'symbol' : '1.2-2' }}
                        </td>
                      </ng-template>
                    </ng-container>

                    <ng-container
                      *ngIf="settledMega.feeDollars == null && settledMega.feeTicks == null"
                    >
                      <td class="td_cell td_cell--is-numeric">
                        {{ 0 | currency: 'USD' : 'symbol' : '1.0' }}
                      </td>
                    </ng-container>

                    <td class="td_cell">{{ settledMega?.committedDate | date: 'MM/dd/yyyy' }}</td>
                    <td class="td_cell">
                      <i
                        class="fa fa-download download-template-icon"
                        (click)="downloadCollateralPool(settledMega)"
                      ></i
                      ><a
                        class="download-pool-info-template download-icon-pos"
                        (click)="downloadCollateralPool(settledMega)"
                        >CSV</a
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </ng-container>

            <ng-container *ngIf="isSingleFamilyArmTabSelected && !showMessage">
              <table class="fm-cdx-table__static">
                <thead>
                  <tr class="th_row">
                    <th
                      class="th_column th_sortable-column sortable-column"
                      (click)="sortByGridByColumnName('poolNumber')"
                    >
                      <span>POOL #</span>
                      <a class="column-name">
                        <i
                          class="sorting-icon-down fa fa-caret-down {{
                            presentSortedColumn === 'poolNumber'
                              ? presentSortedColumnIsAscending
                                ? ''
                                : 'in-active-icon'
                              : 'in-active-icon'
                          }}"
                        ></i>
                        <i
                          class="sorting-icon-up fa fa-caret-up {{
                            presentSortedColumn === 'poolNumber'
                              ? presentSortedColumnIsAscending
                                ? 'in-active-icon'
                                : ''
                              : 'in-active-icon'
                          }}"
                        ></i>
                      </a>
                    </th>
                    <th
                      class="th_column th_sortable-column sortable-column"
                      (click)="sortByGridByColumnName('cusip')"
                    >
                      <span>cusip</span>
                      <a class="column-name">
                        <i
                          class="sorting-icon-down fa fa-caret-down {{
                            presentSortedColumn === 'cusip'
                              ? presentSortedColumnIsAscending
                                ? ''
                                : 'in-active-icon'
                              : 'in-active-icon'
                          }}"
                        ></i>
                        <i
                          class="sorting-icon-up fa fa-caret-up {{
                            presentSortedColumn === 'cusip'
                              ? presentSortedColumnIsAscending
                                ? 'in-active-icon'
                                : ''
                              : 'in-active-icon'
                          }}"
                        ></i>
                      </a>
                    </th>
                    <th class="th_column">prefix</th>
                    <th class="th_column">subtype</th>
                    <th
                      class="th_column th_column--is-numeric th_sortable-column sortable-column"
                      (click)="sortByGridByColumnName('tradeAmount')"
                    >
                      <span>deal amount</span>
                      <a class="column-name">
                        <i
                          class="sorting-icon-down fa fa-caret-down {{
                            presentSortedColumn === 'tradeAmount'
                              ? presentSortedColumnIsAscending
                                ? ''
                                : 'in-active-icon'
                              : 'in-active-icon'
                          }}"
                        ></i>
                        <i
                          class="sorting-icon-up fa fa-caret-up {{
                            presentSortedColumn === 'tradeAmount'
                              ? presentSortedColumnIsAscending
                                ? 'in-active-icon'
                                : ''
                              : 'in-active-icon'
                          }}"
                        ></i>
                      </a>
                    </th>
                    <th
                      class="th_column th_sortable-column sortable-column"
                      (click)="sortByGridByColumnName('tradeSettlementDate')"
                    >
                      <span>settlement</span>
                      <a class="column-name">
                        <i
                          class="sorting-icon-down fa fa-caret-down {{
                            presentSortedColumn === 'tradeSettlementDate'
                              ? presentSortedColumnIsAscending
                                ? ''
                                : 'in-active-icon'
                              : 'in-active-icon'
                          }}"
                        ></i>
                        <i
                          class="sorting-icon-up fa fa-caret-up {{
                            presentSortedColumn === 'tradeSettlementDate'
                              ? presentSortedColumnIsAscending
                                ? 'in-active-icon'
                                : ''
                              : 'in-active-icon'
                          }}"
                        ></i>
                      </a>
                    </th>
                    <th class="th_column th_column--is-numeric">fee</th>
                    <th
                      class="th_column th_sortable-column sortable-column"
                      (click)="sortByGridByColumnName('committedDate')"
                    >
                      <span>committed</span>
                      <a class="column-name">
                        <i
                          class="sorting-icon-down fa fa-caret-down {{
                            presentSortedColumn === 'committedDate'
                              ? presentSortedColumnIsAscending
                                ? ''
                                : 'in-active-icon'
                              : 'in-active-icon'
                          }}"
                        ></i>
                        <i
                          class="sorting-icon-up fa fa-caret-up {{
                            presentSortedColumn === 'committedDate'
                              ? presentSortedColumnIsAscending
                                ? 'in-active-icon'
                                : ''
                              : 'in-active-icon'
                          }}"
                        ></i>
                      </a>
                    </th>
                    <th class="th_column">
                      <span>COLLATERAL</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="td_row"
                    *ngFor="
                      let settledMega of settledSfArmMega.megaList | paginate: config;
                      trackBy: trackByIdentity
                    "
                  >
                    <td
                      class="td_cell poolNumber cusip-disclosure"
                      (click)="openDisclosure(settledMega, settledSfArmMega)"
                    >
                      {{ settledMega?.poolNumber }}
                    </td>
                    <td class="td_cell">{{ settledMega?.cusip }}</td>
                    <td class="td_cell">{{ settledMega?.prefixCode }}</td>
                    <td class="td_cell">{{ settledMega?.sfARMSubType }}</td>
                    <td class="td_cell td_cell--is-numeric">
                      {{ settledMega?.tradeAmount | currency: 'USD' : 'symbol' : '1.0' }}
                    </td>
                    <td class="td_cell">
                      {{ settledMega?.tradeSettlementDate | date: 'MM/dd/yyyy' }}
                    </td>
                    <ng-container *ngIf="settledMega.feeTicks != null">
                      <td class="td_cell td_cell--is-numeric">{{ settledMega?.feeTicks }}/32</td>
                    </ng-container>

                    <ng-container *ngIf="settledMega.feeDollars != null">
                      <td class="td_cell td_cell--is-numeric">
                        {{ settledMega?.feeDollars | currency: 'USD' : 'symbol' : '1.2-2' }}
                      </td>
                    </ng-container>

                    <ng-container
                      *ngIf="settledMega.feeDollars == null && settledMega.feeTicks == null"
                    >
                      <td class="td_cell td_cell--is-numeric">
                        {{ 0 | currency: 'USD' : 'symbol' : '1.0' }}
                      </td>
                    </ng-container>
                    <td class="td_cell">{{ settledMega?.committedDate | date: 'MM/dd/yyyy' }}</td>
                    <td class="td_cell">
                      <i
                        class="fa fa-download download-template-icon"
                        (click)="downloadCollateralPool(settledMega)"
                      ></i
                      ><a
                        class="download-pool-info-template download-icon-pos"
                        (click)="downloadCollateralPool(settledMega)"
                        >CSV</a
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </ng-container>

            <ng-container *ngIf="isMultiFamilyFixTabSelected && !showMessage">
              <table class="fm-cdx-table__static">
                <thead>
                  <tr class="th_row">
                    <th
                      class="th_column th_sortable-column sortable-column"
                      (click)="sortByGridByColumnName('poolNumber')"
                    >
                      <span>POOL #</span>
                      <a class="column-name">
                        <i
                          class="sorting-icon-down fa fa-caret-down {{
                            presentSortedColumn === 'poolNumber'
                              ? presentSortedColumnIsAscending
                                ? ''
                                : 'in-active-icon'
                              : 'in-active-icon'
                          }}"
                        ></i>
                        <i
                          class="sorting-icon-up fa fa-caret-up {{
                            presentSortedColumn === 'poolNumber'
                              ? presentSortedColumnIsAscending
                                ? 'in-active-icon'
                                : ''
                              : 'in-active-icon'
                          }}"
                        ></i>
                      </a>
                    </th>
                    <th
                      class="th_column th_sortable-column sortable-column"
                      (click)="sortByGridByColumnName('cusip')"
                    >
                      <span>cusip</span>
                      <a class="column-name">
                        <i
                          class="sorting-icon-down fa fa-caret-down {{
                            presentSortedColumn === 'cusip'
                              ? presentSortedColumnIsAscending
                                ? ''
                                : 'in-active-icon'
                              : 'in-active-icon'
                          }}"
                        ></i>
                        <i
                          class="sorting-icon-up fa fa-caret-up {{
                            presentSortedColumn === 'cusip'
                              ? presentSortedColumnIsAscending
                                ? 'in-active-icon'
                                : ''
                              : 'in-active-icon'
                          }}"
                        ></i>
                      </a>
                    </th>
                    <th class="th_column">prefix</th>
                    <th class="th_column th_column--is-numeric">high coupon</th>
                    <th class="th_column th_column--is-numeric">low coupon</th>
                    <th
                      class="th_column th_column--is-numeric th_sortable-column sortable-column"
                      (click)="sortByGridByColumnName('tradeAmount')"
                    >
                      <span>deal amount</span>
                      <a class="column-name">
                        <i
                          class="sorting-icon-down fa fa-caret-down {{
                            presentSortedColumn === 'tradeAmount'
                              ? presentSortedColumnIsAscending
                                ? ''
                                : 'in-active-icon'
                              : 'in-active-icon'
                          }}"
                        ></i>
                        <i
                          class="sorting-icon-up fa fa-caret-up {{
                            presentSortedColumn === 'tradeAmount'
                              ? presentSortedColumnIsAscending
                                ? 'in-active-icon'
                                : ''
                              : 'in-active-icon'
                          }}"
                        ></i>
                      </a>
                    </th>
                    <th
                      class="th_column th_sortable-column sortable-column"
                      (click)="sortByGridByColumnName('tradeSettlementDate')"
                    >
                      <span>settlement</span>
                      <a class="column-name">
                        <i
                          class="sorting-icon-down fa fa-caret-down {{
                            presentSortedColumn === 'tradeSettlementDate'
                              ? presentSortedColumnIsAscending
                                ? ''
                                : 'in-active-icon'
                              : 'in-active-icon'
                          }}"
                        ></i>
                        <i
                          class="sorting-icon-up fa fa-caret-up {{
                            presentSortedColumn === 'tradeSettlementDate'
                              ? presentSortedColumnIsAscending
                                ? 'in-active-icon'
                                : ''
                              : 'in-active-icon'
                          }}"
                        ></i>
                      </a>
                    </th>
                    <th class="th_column th_column--is-numeric">fee</th>
                    <th
                      class="th_column th_sortable-column sortable-column"
                      (click)="sortByGridByColumnName('committedDate')"
                    >
                      <span>committed</span>
                      <a class="column-name">
                        <i
                          class="sorting-icon-down fa fa-caret-down {{
                            presentSortedColumn === 'committedDate'
                              ? presentSortedColumnIsAscending
                                ? ''
                                : 'in-active-icon'
                              : 'in-active-icon'
                          }}"
                        ></i>
                        <i
                          class="sorting-icon-up fa fa-caret-up {{
                            presentSortedColumn === 'committedDate'
                              ? presentSortedColumnIsAscending
                                ? 'in-active-icon'
                                : ''
                              : 'in-active-icon'
                          }}"
                        ></i>
                      </a>
                    </th>
                    <th class="th_column">
                      <span>COLLATERAL</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="td_row"
                    *ngFor="
                      let settledMega of settledMfFixMega.megaList | paginate: config;
                      trackBy: trackByIdentity
                    "
                  >
                    <td
                      class="td_cell poolNumber cusip-disclosure"
                      (click)="openDisclosure(settledMega, settledMfFixMega)"
                    >
                      {{ settledMega?.poolNumber }}
                    </td>
                    <td class="td_cell">{{ settledMega?.cusip }}</td>
                    <td class="td_cell">{{ settledMega?.prefixCode }}</td>
                    <td class="td_cell td_cell--is-numeric">{{ settledMega?.mfHighCoupon }}</td>
                    <td class="td_cell td_cell--is-numeric">{{ settledMega?.mfLowCoupon }}</td>
                    <td class="td_cell td_cell--is-numeric">
                      {{ settledMega?.tradeAmount | currency: 'USD' : 'symbol' : '1.0' }}
                    </td>
                    <td class="td_cell">
                      {{ settledMega?.tradeSettlementDate | date: 'MM/dd/yyyy' }}
                    </td>
                    <ng-container *ngIf="settledMega.feeTicks != null">
                      <td class="td_cell td_cell--is-numeric">{{ settledMega?.feeTicks }}/32</td>
                    </ng-container>

                    <ng-container *ngIf="settledMega.feeDollars != null">
                      <td class="td_cell td_cell--is-numeric">
                        {{ settledMega?.feeDollars | currency: 'USD' : 'symbol' : '1.2-2' }}
                      </td>
                    </ng-container>

                    <ng-container
                      *ngIf="settledMega.feeDollars == null && settledMega.feeTicks == null"
                    >
                      <td class="td_cell td_cell--is-numeric">
                        {{ 0 | currency: 'USD' : 'symbol' : '1.0' }}
                      </td>
                    </ng-container>
                    <td class="td_cell">{{ settledMega?.committedDate | date: 'MM/dd/yyyy' }}</td>
                    <td class="td_cell">
                      <i
                        class="fa fa-download download-template-icon"
                        (click)="downloadCollateralPool(settledMega)"
                      ></i
                      ><a
                        class="download-pool-info-template download-icon-pos"
                        (click)="downloadCollateralPool(settledMega)"
                        >CSV</a
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </ng-container>

            <ng-container *ngIf="isMultiFamilyArmTabSelected && !showMessage">
              <table class="fm-cdx-table__static">
                <thead>
                  <tr class="th_row">
                    <th
                      class="th_column th_sortable-column sortable-column"
                      (click)="sortByGridByColumnName('poolNumber')"
                    >
                      <span>POOL #</span>
                      <a class="column-name">
                        <i
                          class="sorting-icon-down fa fa-caret-down {{
                            presentSortedColumn === 'poolNumber'
                              ? presentSortedColumnIsAscending
                                ? ''
                                : 'in-active-icon'
                              : 'in-active-icon'
                          }}"
                        ></i>
                        <i
                          class="sorting-icon-up fa fa-caret-up {{
                            presentSortedColumn === 'poolNumber'
                              ? presentSortedColumnIsAscending
                                ? 'in-active-icon'
                                : ''
                              : 'in-active-icon'
                          }}"
                        ></i>
                      </a>
                    </th>
                    <th
                      class="th_column th_sortable-column sortable-column"
                      (click)="sortByGridByColumnName('cusip')"
                    >
                      <span>cusip</span>
                      <a class="column-name">
                        <i
                          class="sorting-icon-down fa fa-caret-down {{
                            presentSortedColumn === 'cusip'
                              ? presentSortedColumnIsAscending
                                ? ''
                                : 'in-active-icon'
                              : 'in-active-icon'
                          }}"
                        ></i>
                        <i
                          class="sorting-icon-up fa fa-caret-up {{
                            presentSortedColumn === 'cusip'
                              ? presentSortedColumnIsAscending
                                ? 'in-active-icon'
                                : ''
                              : 'in-active-icon'
                          }}"
                        ></i>
                      </a>
                    </th>
                    <th class="th_column">prefix</th>
                    <th class="th_column">subtype</th>
                    <th
                      class="th_column th_column--is-numeric th_sortable-column sortable-column"
                      (click)="sortByGridByColumnName('tradeAmount')"
                    >
                      <span>deal amount</span>
                      <a class="column-name">
                        <i
                          class="sorting-icon-down fa fa-caret-down {{
                            presentSortedColumn === 'tradeAmount'
                              ? presentSortedColumnIsAscending
                                ? ''
                                : 'in-active-icon'
                              : 'in-active-icon'
                          }}"
                        ></i>
                        <i
                          class="sorting-icon-up fa fa-caret-up {{
                            presentSortedColumn === 'tradeAmount'
                              ? presentSortedColumnIsAscending
                                ? 'in-active-icon'
                                : ''
                              : 'in-active-icon'
                          }}"
                        ></i>
                      </a>
                    </th>
                    <th
                      class="th_column th_sortable-column sortable-column"
                      (click)="sortByGridByColumnName('tradeSettlementDate')"
                    >
                      <span>settlement</span>
                      <a class="column-name">
                        <i
                          class="sorting-icon-down fa fa-caret-down {{
                            presentSortedColumn === 'tradeSettlementDate'
                              ? presentSortedColumnIsAscending
                                ? ''
                                : 'in-active-icon'
                              : 'in-active-icon'
                          }}"
                        ></i>
                        <i
                          class="sorting-icon-up fa fa-caret-up {{
                            presentSortedColumn === 'tradeSettlementDate'
                              ? presentSortedColumnIsAscending
                                ? 'in-active-icon'
                                : ''
                              : 'in-active-icon'
                          }}"
                        ></i>
                      </a>
                    </th>
                    <th class="th_column th_column--is-numeric">fee</th>
                    <th
                      class="th_column th_sortable-column sortable-column"
                      (click)="sortByGridByColumnName('committedDate')"
                    >
                      <span>committed</span>
                      <a class="column-name">
                        <i
                          class="sorting-icon-down fa fa-caret-down {{
                            presentSortedColumn === 'committedDate'
                              ? presentSortedColumnIsAscending
                                ? ''
                                : 'in-active-icon'
                              : 'in-active-icon'
                          }}"
                        ></i>
                        <i
                          class="sorting-icon-up fa fa-caret-up {{
                            presentSortedColumn === 'committedDate'
                              ? presentSortedColumnIsAscending
                                ? 'in-active-icon'
                                : ''
                              : 'in-active-icon'
                          }}"
                        ></i>
                      </a>
                    </th>
                    <th class="th_column">
                      <span>COLLATERAL</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="td_row"
                    *ngFor="
                      let settledMega of settledMfArmMega.megaList | paginate: config;
                      trackBy: trackByIdentity
                    "
                  >
                    <td
                      class="td_cell poolNumber cusip-disclosure"
                      (click)="openDisclosure(settledMega, settledMfArmMega)"
                    >
                      {{ settledMega?.poolNumber }}
                    </td>
                    <td class="td_cell">{{ settledMega?.cusip }}</td>
                    <td class="td_cell">{{ settledMega?.prefixCode }}</td>
                    <td class="td_cell">{{ settledMega?.sfARMSubType }}</td>
                    <td class="td_cell td_cell--is-numeric">
                      {{ settledMega?.tradeAmount | currency: 'USD' : 'symbol' : '1.0' }}
                    </td>
                    <td class="td_cell">
                      {{ settledMega?.tradeSettlementDate | date: 'MM/dd/yyyy' }}
                    </td>
                    <ng-container *ngIf="settledMega.feeTicks != null">
                      <td class="td_cell td_cell--is-numeric">{{ settledMega?.feeTicks }}/32</td>
                    </ng-container>

                    <ng-container *ngIf="settledMega.feeDollars != null">
                      <td class="td_cell td_cell--is-numeric">
                        {{ settledMega?.feeDollars | currency: 'USD' : 'symbol' : '1.2-2' }}
                      </td>
                    </ng-container>

                    <ng-container
                      *ngIf="settledMega.feeDollars == null && settledMega.feeTicks == null"
                    >
                      <td class="td_cell td_cell--is-numeric">
                        {{ 0 | currency: 'USD' : 'symbol' : '1.0' }}
                      </td>
                    </ng-container>
                    <td class="td_cell">{{ settledMega?.committedDate | date: 'MM/dd/yyyy' }}</td>
                    <td class="td_cell">
                      <i
                        class="fa fa-download download-template-icon"
                        (click)="downloadCollateralPool(settledMega)"
                      ></i
                      ><a
                        class="download-pool-info-template download-icon-pos"
                        (click)="downloadCollateralPool(settledMega)"
                        >CSV</a
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </ng-container>
          </div>
        </div>
      </ng-container>

      <p class="fee-warning-red">
        <ng-container *ngIf="isSingleFamilyFixTabSelected">
          {{ disclaimerMessage }}
        </ng-container>
      </p>

      <ng-container *ngIf="displayPagination">
        <pagination-template
          #p="paginationApi"
          [id]="config.id"
          (pageChange)="config.currentPage = $event"
        >
          <nav
            aria-label="Page navigation"
            class="settled-exchanges-pagination d-flex justify-content-end"
          >
            <ul class="pagination">
              <li class="page-item pagination-previous" [class.disabled]="p.isFirstPage()">
                <a class="page-link" (click)="p.previous()">
                  <span aria-hidden="true">PREV</span>
                </a>
              </li>

              <li
                class="page-item"
                *ngFor="let page of p.pages; trackBy: trackByIdentity"
                [class.active]="p.getCurrent() === page.value"
              >
                <a
                  class="page-link"
                  [ngClass]="{ ellipse: page.label === '...' }"
                  (click)="p.setCurrent(page.value)"
                  *ngIf="p.getCurrent() !== page.value"
                >
                  <span>{{ page.label }}</span>
                </a>
                <a class="page-link" *ngIf="p.getCurrent() === page.value">
                  <span>{{ page.label }}</span>
                </a>
              </li>

              <li class="page-item pagination-next" [class.disabled]="p.isLastPage()">
                <a class="page-link" (click)="p.next()">
                  <span aria-hidden="true">NEXT</span>
                </a>
              </li>
            </ul>
          </nav>
        </pagination-template>
      </ng-container>
    </div>
  </div>
</div>
